import { SitesListSitesDocument, SitesListSitesQuery, SitesListSitesQueryVariables } from "@gql/li-api/graphql";
import { feature } from "@turf/helpers";
import { SelectionType } from "src/js/stores/map/store";
import { getSite } from "src/js/api/sites";
import { zoomToSelection } from "react-migration/lib/map/zoomToSelection";
import { routedClient } from "react-migration/lib/persistence/apollo";
import { SearchAutocompleteSection } from "../../types";
import { ErrorWithToast } from "../../ErrorWithToast";

export const savedSitesAutocompleteSection: SearchAutocompleteSection = {
  id: "sites",
  title: "Saved Sites",

  async fetchResults(search: string) {
    if (!search?.length) return [];

    const sitesResponse = await routedClient.query<SitesListSitesQuery, SitesListSitesQueryVariables>({
      query: SitesListSitesDocument,
      variables: {
        searchString: search,
        first: 10,
      },
    });

    return (
      sitesResponse.data?.sites?.edges?.map((edge) => ({
        id: edge.node._id,
        title: edge.node.title ?? "",
        workspace: edge.node._stage?._workspace ?? undefined,
      })) ?? []
    );
  },

  async onSelectionHandler(result, { setSelection, map }) {
    const site = await getSite(result.id);

    if (!site || !site.geometry) {
      throw new ErrorWithToast("Site not found", "Ensure the site in question hasn't been deleted.");
    }

    zoomToSelection(site.geometry, map);

    setSelection({
      type: SelectionType.SITE,
      id: site.id,
      savable: false,
      feature: feature(site.geometry),
    });

    return { siteName: site.title };
  },
};
